import i18n from "i18next";
import { initReactI18next } from "react-i18next";
//import {getLocale} from '../Redux/App/AppReducer';
import enTranslation from "@/Translation/us/translation.json";
import { getLocale } from "@/Redux/App/AppReducer";

const resources = {
    us: {
        translation: enTranslation,
    }
};

i18n.use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: getLocale(),

        keySeparator: ".", // activated GT

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
        fallbackLng: "de",
    });

export default i18n;
